import { orchestrator } from 'satcheljs';
import showQuickOptionsAction from 'owa-options-actions/lib/showQuickOptions';
import openQuickOptions from '../utils/openQuickOptions';

const owaSettingsFlexPaneID = 'OwaSettings';

orchestrator(showQuickOptionsAction, () => {
    openQuickOptions(owaSettingsFlexPaneID);
});
